import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

class AuthorManagement extends Component {
  state = {
    authors: [],
    pageNo: 1,
    length: 0,
    newAuthor: "",
    authorImage: null,
    editingMonth: "",
    editingQuote: null,
    profileLink: "", // New field
    editingAuthor: null,
    showPopup: false,
    showQuotePopup: false,
    showAddQuotePopup: false,
    showEditQuotePopup: false,
    selectedAuthor: null,
    newQuote: "",
    newQuoteTitle: "",
    newStoryLink: "",
      windowWidth: window.innerWidth,

  };

// Add this method to your component
componentDidMount() {
  this.fetchAuthors();
  window.addEventListener('resize', this.handleResize);
}

componentWillUnmount() {
  window.removeEventListener('resize', this.handleResize);
}

handleResize = () => {
  this.setState({ windowWidth: window.innerWidth });
};



  fetchAuthors = async () => {
    try {
      let token = getAccessToken();
      const response = await Axios.get(
        `${Constant.apiBasePath}spotlight/author/get-all`,
        { headers: { token } }
      );
      const { data } = response.data;
      this.setState({
        authors: data || [],
        pageNo: data.pageNo || 1,
        length: data.length || 0,
      });
    } catch (error) {
      console.error("Error fetching authors:", error);
    }
  };

  togglePopup = (author = null, quote = null) => {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
      newAuthor: author ? author.author : "",
      authorImage: author ? author.imageUrl || null : null,
      editingMonth: author ? author.month || "" : "",
      profileLink: author ? author.profileLink || "" : "", // Populate profileLink
      editingAuthor: author,
      editingQuote: quote,
    }));
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageUpload = async (file) => {
    try {
      if (!file) {
        alert("Please select a file.");
        return;
      }

      let token = getAccessToken();
      let formData = new FormData();
      formData.append("spotlight", file, file.name);
      const response = await Axios.post(
        `${Constant.apiBasePath}spotlight/uploadFileOnS3`,
        formData,
        { headers: { token, "Content-Type": "multipart/form-data" } }
      );

      const { data } = response;
      if (data.status === "Success") {
        this.setState({ authorImage: data.location });
      } else {
        console.error("Error uploading image:", data.message);
        alert("Image upload failed.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Image upload failed.");
    }
  };

  addOrUpdateAuthor = async () => {
    try {
      const {
        newAuthor,
        editingAuthor,
        authorImage,
        editingMonth,
        profileLink,
      } = this.state;

      if (!newAuthor.trim()) {
        alert("Author name is required.");
        return;
      }

      if (profileLink && !/^(http|https):\/\/[^ "]+$/.test(profileLink)) {
        alert("Invalid profile link URL.");
        return;
      }

      let token = getAccessToken();
      let response;

      if (editingAuthor) {
        response = await Axios.patch(
          `${Constant.apiBasePath}spotlight/author/${editingAuthor._id}`,
          {
            author: newAuthor,
            imageUrl: authorImage,
            month: editingMonth,
            profileLink, // Include profileLink
          },
          { headers: { token } }
        );
      } else {
        response = await Axios.post(
          `${Constant.apiBasePath}spotlight/author`,
          {
            author: newAuthor,
            imageUrl: authorImage,
            month: editingMonth,
            profileLink, // Include profileLink
          },
          { headers: { token } }
        );
      }

      const { data } = response;
      if (data.status === "Success" || data.status === "success") {
        this.fetchAuthors();
        this.setState({ showPopup: false });
        alert(
          editingAuthor
            ? "Author updated successfully!"
            : "Author created successfully!"
        );
      } else {
        console.error("Error saving data:", data.message);
        alert("An error occurred while saving data.");
      }
    } catch (error) {
      console.error("Error adding/updating author:", error);
      alert("An unexpected error occurred.");
    }
  };

  deleteAuthor = async (authorId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}spotlight/author/${authorId}`,
        { headers: { token } }
      );
      const { data } = response;
      if (data.status === "success") {
        this.setState((prevState) => ({
          authors: prevState.authors.filter(
            (author) => author._id !== authorId
          ),
        }));
      } else {
        console.error("Error deleting author:", data.message);
      }
    } catch (error) {
      console.error("Error deleting author:", error);
    }
  };

  toggleQuotePopup = (author = null) => {
    this.setState((prevState) => ({
      showQuotePopup: !prevState.showQuotePopup,
      selectedAuthor: author,
      showAddQuotePopup: false,
      showEditQuotePopup: false,
    }));
    this.resetFormFields();
  };

  toggleAddQuotePopup = () => {
    this.setState((prevState) => ({
      showAddQuotePopup: !prevState.showAddQuotePopup,
    }));
    this.resetFormFields();
  };

  toggleEditQuotePopup = (quote = null) => {
    this.setState((prevState) => ({
      showEditQuotePopup: !prevState.showEditQuotePopup,
      editingQuote: quote,
      newQuote: quote ? quote.quote : "",
      newQuoteTitle: quote ? quote.title : "",
      newStoryLink: quote ? quote.storyLink : "",
    }));
  };

  handleQuoteSubmit = async () => {
    try {
      const {
        selectedAuthor,
        editingQuote,
        newQuote,
        newQuoteTitle,
        newStoryLink,
      } = this.state;
      let token = getAccessToken();

      if (!newQuote.trim() || !newQuoteTitle.trim() || !newStoryLink.trim()) {
        alert("All fields are required");
        return;
      }

      const quoteData = {
        quote: newQuote,
        title: newQuoteTitle,
        storyLink: newStoryLink,
      };

      if (editingQuote) {
        // Update quote
        const response = await Axios.put(
          `${Constant.apiBasePath}spotlight/quote/${selectedAuthor._id}/${editingQuote._id}`,
          quoteData,
          { headers: { token } }
        );

        if (response.data.status === "Success") {
          // Get updated author data from response
          const updatedAuthorData = response.data.data;

          // Update authors array with new data
          const updatedAuthors = this.state.authors.map((author) =>
            author._id === updatedAuthorData._id ? updatedAuthorData : author
          );

          this.setState({
            authors: updatedAuthors,
            selectedAuthor: updatedAuthorData,
            showEditQuotePopup: false,
            newQuote: "",
            newQuoteTitle: "",
            newStoryLink: "",
            editingQuote: null,
          });
        }
      } else {
        // Add new quote
        const response = await Axios.post(
          `${Constant.apiBasePath}spotlight/quote/${selectedAuthor._id}`,
          quoteData,
          { headers: { token } }
        );

        if (response.data.status === "Success") {
          // Get updated author data from response
          const updatedAuthorData = response.data.data;

          // Update authors array with new data
          const updatedAuthors = this.state.authors.map((author) =>
            author._id === updatedAuthorData._id ? updatedAuthorData : author
          );

          this.setState({
            authors: updatedAuthors,
            selectedAuthor: updatedAuthorData,
            showAddQuotePopup: false,
            newQuote: "",
            newQuoteTitle: "",
            newStoryLink: "",
          });
          alert("Quote added successfully!");
        }
      }
    } catch (error) {
      console.error("Error saving quote:", error);
      alert("An error occurred while saving the quote.");
    }
  };

  deleteQuote = async (authorId, quoteId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}spotlight/quote/${authorId}/${quoteId}`,
        { headers: { token } }
      );

      if (response.data.status === "Success") {
        // Get updated author data from response
        const updatedAuthorData = response.data.data;

        // Update authors array with new data
        const updatedAuthors = this.state.authors.map((author) =>
          author._id === updatedAuthorData._id ? updatedAuthorData : author
        );

        this.setState({
          authors: updatedAuthors,
          selectedAuthor: updatedAuthorData,
        });
        alert("Quote deleted successfully!");
      }
    } catch (error) {
      console.error("Error deleting quote:", error);
      alert("An error occurred while deleting the quote.");
    }
  };

  resetFormFields = () => {
    this.setState({
      newQuote: "",
      newQuoteTitle: "",
      newStoryLink: "",
      editingQuote: null,
    });
  };

  render() {
    const {
      authors,
      showPopup,
      newAuthor,
      authorImage,
      profileLink,
      showQuotePopup,
      selectedAuthor,
      showAddQuotePopup,
      showEditQuotePopup,
      newQuote,
      newQuoteTitle,
      newStoryLink,
    } = this.state;

     const { windowWidth } = this.state;
  
  // Determine grid columns based on screen width
  let gridColumns = 3; // Default for desktop
  if (windowWidth <= 576) {
    gridColumns = 1; // Mobile
  } else if (windowWidth <= 992) {
    gridColumns = 2; // Tablet
  }
    // Add these new styles
    const quoteGridStyle = {
      display: "grid",
    gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
      gap: "20px",
      maxHeight: "500px", // Adjust height as needed
      overflowY: "auto",
      padding: "20px",

     
    };

    const quoteCardStyle = {
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: "8px",
      padding: "15px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    };

    return (
      <div className="content-page">
        <div className="header-common">
          <div className="center-items">
            <h4 className="page-title-heading">Author Management</h4>
          </div>
          <div className="center-items text-right">
            <button className="btn btn-info" onClick={() => this.togglePopup()}>
              Add New Author
            </button>
          </div>
        </div>
        {showPopup && (
          <div style={popupContainerStyle}>
            <div style={popupStyle}>
              <h4>{this.state.editingAuthor ? "Edit Author" : "Add Author"}</h4>
              <input
                type="text"
                name="newAuthor"
                placeholder="Author Name"
                value={newAuthor}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              <input
                type="file"
                onChange={(e) => this.handleImageUpload(e.target.files[0])}
                style={inputStyle}
              />
              <input
                type="text"
                name="editingMonth"
                placeholder="Month"
                value={this.state.editingMonth}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              <input
                type="text"
                name="profileLink"
                placeholder="Profile Link"
                value={profileLink}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              {authorImage && (
                <div>
                  <img
                    src={authorImage}
                    alt="Author"
                    style={{ width: "100px", marginBottom: "15px" }}
                  />
                </div>
              )}
              <button className="btn btn-secondary" onClick={this.togglePopup}>
                Cancel
              </button>
              <button
                className="btn btn-primary ml-2"
                onClick={this.addOrUpdateAuthor}
              >
                Save
              </button>
            </div>
          </div>
        )}

        {showQuotePopup && (
  <div style={popupContainerStyle}>
    <div className="quote-modal">
      {/* Header */}
      <div className="quote-modal-header">
        <h4 style={{ margin: 0, marginBottom: "15px" }}>Quote Management</h4>
        <button
          className="btn btn-success"
          onClick={this.toggleAddQuotePopup}
        >
          Add New Quote
        </button>
      </div>

      {/* Scrollable Body */}
      <div className="quote-modal-body">
        {selectedAuthor && (
          <div className="quote-grid">
            {selectedAuthor.quotes.map((quote) => (
              <div key={quote._id} className="quote-card">
                <h5 className="mb-2">{quote.title}</h5>
                <p className="mb-2" style={{ flex: 1 }}>
                  {quote.quote}
                </p>
                <a
                  href={quote.storyLink}
                  target="_blank"
                  rel="noreferrer"
                  className="mb-2 text-primary"
                >
                  Story Link
                </a>
                <div className="d-flex gap-2" style={{ gap: "10px" }}>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => this.toggleEditQuotePopup(quote)}
                  >
                    <FontAwesomeIcon icon={faEdit} /> Edit
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() =>
                      this.deleteQuote(selectedAuthor._id, quote._id)
                    }
                  >
                    <FontAwesomeIcon icon={faTrashAlt} /> Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="quote-modal-footer">
        <button
          className="btn btn-secondary"
          onClick={this.toggleQuotePopup}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

        {/* Add Quote Popup */}
        {showAddQuotePopup && (
          <div style={popupContainerStyle}>
            <div style={popupStyle}>
              <h4>Add New Quote</h4>
              <input
                type="text"
                name="newQuoteTitle"
                placeholder="Title"
                value={newQuoteTitle}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              <textarea
                name="newQuote"
                placeholder="Quote"
                value={newQuote}
                onChange={this.handleInputChange}
                style={{ ...inputStyle, minHeight: "100px" }}
              />
              <input
                type="text"
                name="newStoryLink"
                placeholder="Story Link"
                value={newStoryLink}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              <button
                className="btn btn-secondary mr-2"
                onClick={this.toggleAddQuotePopup}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.handleQuoteSubmit}
              >
                Save Quote
              </button>
            </div>
          </div>
        )}

        {/* Edit Quote Popup */}
        {showEditQuotePopup && (
          <div style={popupContainerStyle}>
            <div style={popupStyle}>
              <h4>Edit Quote</h4>
              <input
                type="text"
                name="newQuoteTitle"
                placeholder="Title"
                value={newQuoteTitle}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              <textarea
                name="newQuote"
                placeholder="Quote"
                value={newQuote}
                onChange={this.handleInputChange}
                style={{ ...inputStyle, minHeight: "100px" }}
              />
              <input
                type="text"
                name="newStoryLink"
                placeholder="Story Link"
                value={newStoryLink}
                onChange={this.handleInputChange}
                style={inputStyle}
              />
              <button
                className="btn btn-secondary mr-2"
                onClick={this.toggleEditQuotePopup}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.handleQuoteSubmit}
              >
                Update Quote
              </button>
            </div>
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Author</th>
                <th>Image</th>
                <th>Month</th>
                <th>Profile Link</th>
                <th>Quote</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {authors.map((author) => (
                <tr key={author._id}>
                  <td className="namecol">{author.author}</td>
                  <td>
                    {author.imageUrl && (
                      <img
                        src={author.imageUrl}
                        alt="Author"
                        style={{ width: "50px", height: "50px" }}
                      />
                    )}
                  </td>
                  <td>{author.month || "N/A"}</td>
                  <td  className="namecol">
                    {author.profileLink ? (
                      <a
                        href={author.profileLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Profile
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>{author.quotes.length || "N/A"}</td>
                  <td >
                    <button
                      className="btn btn-primary mr-2"
                      onClick={() => this.togglePopup(author)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      className="btn btn-info mr-2"
                      onClick={() => this.toggleQuotePopup(author)}
                    >
                      Manage Quotes
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => this.deleteAuthor(author._id)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default withRouter(AuthorManagement);

const popupContainerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const popupStyle = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  width: "400px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "15px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  color: "black",
};

// Also add this CSS to your stylesheet or in a <style> tag
const styles = `
  @media (max-width: 992px) {
    .quote-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
  
  @media (max-width: 576px) {
    .quote-grid {
      grid-template-columns: 1fr !important;
    }
  }
  
  .quote-grid::-webkit-scrollbar {
    width: 8px;
  }
  
  .quote-grid::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .quote-grid::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  .quote-grid::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
